import { Component, Input, OnInit } from "@angular/core";
import { ManageEmployeeContractService } from "../../../../../auth/service/manage-employee-contract.service";
import { ContractService } from "../../../../../auth/service/contract.service";
import moment from "moment/moment";
import { UtilsService } from "../../../../../auth/service/utils.service";
import { UserFigureService } from "../../../../../auth/service/user-figure.service";
import { FormBuilder, FormControl, FormGroup, Validators } from "@angular/forms";
import { AuthenticationService, UserService } from "../../../../../auth/service";
import { HttpClient, HttpRequest } from "@angular/common/http";
import { Router } from "@angular/router";

/**
 * creare due record nella tabella user_contracts, uno con il contratto iniziale (scrivilo nel type) l'altro con il contratto aggiornato
 * salva gli aggiornamenti sempre nelle note dell'utente
 * --
 * all'aggiornamento di user_costs aggiorna i dati relativi nella tabella del contratto e toglili da lì, controllare i dati da aggiornare e chiedere a
 * Gigi come calcolare il costo giornaliero e il resto che manca.
 */
@Component({
  selector: "app-user-form-contract",
  templateUrl: "./user-form-contract.component.html",
  styleUrls: ["./user-form-contract.component.scss"],
})
export class UserFormContractComponent implements OnInit {
  @Input() currentUser: any = null;
  public contract_is_changed: boolean = false;
  public insert_valid_since: boolean = false;
  public is_resigned: boolean = false;
  public typeResignation: string = "resignation";
  public valid_since: any;
  public today_date: string = moment().format("YYYY-MM-DD");
  public updateAbsencesFormGroup: FormGroup;
  public fileNameResignation: string = null;
  public fileResignation: any;
  public openContractTab: any = "update_contract";
  public fileNameContract: string = null;
  public fileContract: any = null;
  public contractAttachmentsList: any[] = [];
  public contractAttachmentsList_obj: any[] = [];
  public uploadErrors: any[] = [];
  public isUploading: boolean = false;
  public currentContract: any = {};

  constructor(
    private _formBuilder: FormBuilder,
    public _utilsService: UtilsService,
    public _contractService: ContractService,
    public _userFigureService: UserFigureService,
    public _manageContract: ManageEmployeeContractService,
    public _authenticationService: AuthenticationService,
    public _userService: UserService,
    private _httpClient: HttpClient,
    private router: Router,
  ) {
    this.updateAbsencesFormGroup = this._formBuilder.group({
      residual_holidays: new FormControl(0, [Validators.min(0), Validators.required]),
      residual_permissions: new FormControl(0, [Validators.min(0), Validators.required]),
    });
  }

  async ngOnInit() {
    await this._contractService.getLevels();

    this.updateAbsencesFormGroup.patchValue({
      residual_holidays: this.currentUser.residual_holidays,
      residual_permissions: this.currentUser.residual_permissions,
    })

    await this._manageContract.init(this.currentUser.contract).then(() => {
      if (this._manageContract.data.closed_at || this.currentUser.contract.resignation_url || this.currentUser?.contract?.file_dimissional) {
        // Controllo che ci sia un licenziamento o una dimissione
        this.typeResignation = this.currentUser?.contract?.resignation_url ? "resignation" : this.currentUser?.contract?.file_dimissional ? "dismissal" : "resignation";
      }

      this.currentContract = {
        name: this.currentUser.contract_active.contract_name,
        ral: this.currentUser.contract_active.salary_yearly_gross,
        bonus: this.currentUser.contract_active.bonus,
        production_bonus: this.currentUser.contract_active.production_bonus || 0,
        net_monthly_12: this.currentUser.contract_active.net_monthly_12,
        net_monthly_13: this.currentUser.contract_active.net_monthly_13,
        total_daily: this.currentUser.contract_active.total_daily,
        start_date: this.currentUser.contract_active.start_date,
        end_date: this.currentUser.contract_active.end_date,
        level: this.currentUser.contract_active.level,
        trial: this.currentUser.contract_active.trial, // --> non esiste
        program: this.currentUser.contract_active.program, // --> non esiste
        figure: this.currentUser.contract_active.figure_name,
        duration: moment(this.currentUser.contract_active.end_date).diff(this.currentUser.contract_active.start_date, "months"),
        ticket_type: this.currentUser.contract_active.ticket_type === "fisso" ? "STATIC" : "VARIABLE",
        ticket_month_number: this.currentUser.contract_active.ticket_month_number || 0,
        ticket_value: this.currentUser.contract_active.ticket_value || 0,
        closed_at: this.currentUser.contract_active.closed_at || null,
      };

      this.is_resigned = this.currentUser.contract && !!this.currentUser.contract.closed_at;

      if (this._manageContract.typeIsApprendistato || this._manageContract.typeIsStage) {
        this.currentContract.tutor = this.currentUser.contract.tutor_name;
      }

      if (this.is_resigned) {
        this.openContractTab = "current_contract";
      }
    });
  }

  toggleModal(selector: any) {
    this.openContractTab = this.openContractTab === selector ? "" : selector;
  }

  // visualizza un documento a partire da un URL
  async viewDocument(url: string) {
    await this._utilsService.getFile(url);
  }

  // controllo trasformazione della ral
  async transformRal(value: any) {
    const splittedValue: any = value.split("");

    if (value.includes(",") && splittedValue[splittedValue.length - 3] === "," && value.includes(".") && splittedValue[2] === ".") {
      value = this._utilsService.removeDotsFromNumber(value);
    } else {
      // se include il punto e il punto è usato a index 2 - rimuovo quel punto
      if (value.includes(".") && splittedValue[2] === ".") {
        value = value.split("");
        delete value[2];
        value = value.join("");
      }
      // se include la virgola e la virgola è alla index 2 - rimuovo quella virgola
      if (value.includes(",") && splittedValue[2] === ",") {
        value = value.split("");
        delete value[2];
        value = value.join("");
      }
      // se include la virgola ed è il separatore dei decimali
      if (value.includes(",") && splittedValue[splittedValue.length - 3] === ",") {
        value = value.split("");
        value[-2] = ".";
        value = value.join("");
      }
    }

    value = Number(value);

    await this._manageContract.changeSalaryGrossYearly(value);
  }

  // --- INIZIO FUNZIONI PER DOCUMENTI E ALLEGATI
  handlerChangeContractFile(event: any) {
    this.fileNameContract = event.target.files[0].name;
    this._utilsService.convertFileToBase64(event, (e: any) => {
      this.fileContract = e.target.result;
    });
  }

  async uploadContract() {
    const contractFileName: any = `users/${this.currentUser.hash}/Contratto-${this.currentUser.contract.contract_name}-${moment().valueOf()}.pdf`;

    const uploadContract: any = await this._utilsService.upload_media("documents", contractFileName, this.fileContract);

    if (!uploadContract) {
      await this._utilsService.showSWALError({ text: "ERROR_UPLOAD_CONTRACT" });
      return false;
    }

    await this._userService.update(this.currentUser.hash, { contract_url: contractFileName }).then(async () => {
      this.currentUser.contract_url = contractFileName;
      await this._utilsService.showSWALSuccess({ text: "SUCCESS_UPLOAD_CONTRACT" });
      this.fileNameContract = null;
      this.fileContract = null;
    });
  }

  async handlerChangeContractAttachments($event: any) {
    const files: any[] = $event.target.files;
    // creo una variabile dalla lista attuale
    let updatedList: any[] = this.contractAttachmentsList_obj.filter((item: any) => item.name !== "");
    // ciclo tutti i files inviati
    for (let file of files) {
      // controllo le dimensioni
      if (file.size > 10000000) {
        await this._utilsService.showSWALError({ text: "ERROR_MAX_FILE_SIZE" });
        continue;
      }
      // se esiste già nella lista lo tolgo
      const exists: any = updatedList.find((item: any) => item.name === file.name);
      // se esiste lo rimuovo
      if (!exists) {
        // se non esiste lo metto nell'array dei files
        // aggiungo ai files
        this.contractAttachmentsList.push(file);
        // aggiungo alla lista
        updatedList.push({
          name: file.name,
          size: this._utilsService.formatBytes(file.size),
          status: 0,
        });
      }
    }
    // aggiorno variabile della pagina
    this.contractAttachmentsList_obj = updatedList;
    // resetto l'input
    const inputUploadAttachments: any = document.querySelector("#attachmentSection input.custom-file-input");
    inputUploadAttachments.value = null;
  }

  resetFilesList() {
    this.contractAttachmentsList_obj = [];
    this.contractAttachmentsList = [];
  }

  removeFileFromList(index: any) {
    this.contractAttachmentsList_obj = this.contractAttachmentsList_obj.filter((item: any, i: number) => i !== index);
    this.contractAttachmentsList = this.contractAttachmentsList.filter((item: any, i: number) => i !== index);
  }

  uploadFiles() {
    this.isUploading = true;
    if (!this.currentUser.contract.contract_attachments) {
      this.currentUser.contract.contract_attachments = [];
    }
    // aspetto che tutti i file vengano processati
    Promise.all(
      this.contractAttachmentsList.map((file: File, index: number) => {
        const formData: FormData = new FormData();
        formData.append("file", file);

        const req: any = new HttpRequest("PUT", `/user/${this.currentUser.hash}`, formData);

        this.contractAttachmentsList_obj[index].status = 1;

        return this._httpClient
          .request(req)
          .toPromise()
          .then(() => {
            this.contractAttachmentsList_obj[index].status = 2;
            this.currentUser.contract.contract_attachments.push({
              url: `users/${this.currentUser.hash}/${this.contractAttachmentsList_obj[index].name}`,
              file_name: this.contractAttachmentsList_obj[index].name.replace(".pdf", ""),
            });
            //Ricarico per aggiornare gli attachment di currentUser altrimenti non avremmo gli id degli attachment ed l'elimina non funzionerebbe
            window.location.reload();
          })
          .catch((err: any) => {
            this.contractAttachmentsList_obj[index].status = 3;
            this.uploadErrors.push({
              filename: this.contractAttachmentsList_obj[index].name,
              error: err.toUpperCase().replace(/\s/gi, "_"),
            });
          });
      }),
    ).then(async () => {
      // istanzio la variabile d'errore
      let error = false;
      //ciclo sull'array dei file
      for (const fileObj of this.contractAttachmentsList_obj) {
        //se trovo un file con status a 3 faccio partire l'errore
        if (fileObj.status === 3) {
          error = true;
          break;
        }
      }
      this.isUploading = false;
      //se non ci sta nessun errore, carico la data di caricamento
      if (!error) {
        this.resetFilesList();
        await this._utilsService.showSWALSuccess({ text: "SUCCESS_UPLOAD_FILES" });
      } else {
        // altrimenti no
        await this._utilsService.showSWALError({ text: "ERROR_UPLOAD_FILES" });
      }
    });
  }

  // --- FINE FUNZIONI PER DOCUMENTI E ALLEGATI

  saveResidualAbsences() {
    if (this.updateAbsencesFormGroup.invalid) {
      return this._utilsService.showSWALError({ text: "CHECK_EMPLOYEE_ABSENCES_FIELDS" });
    }

    this._utilsService.showLoading();
    this._userService
      .updateEmployeeAbsences(this.currentUser.hash, {
        residual_holidays: Number(this.updateAbsencesFormGroup.value.residual_holidays),
        residual_permissions: Number(this.updateAbsencesFormGroup.value.residual_permissions),
      })
      .then(async () => {
        this._utilsService.hideLoading();
        await this._utilsService.showSWALSuccess({ text: "SUCCESS_UPDATE_EMPLOYEE_RESIDUAL_ABSENCES" });
      })
      .catch(async (err: any) => {
        await this._utilsService.showSWALError({ text: "ERROR_UPDATE_EMPLOYEE_RESIDUAL_ABSENCES" });
        console.error(err);
      });
  }

  // --- INIZIO FUNZIONI PER DIMISSIONI

  async saveResignation() {
    if ((this.fileNameResignation || this._manageContract.data.closed_reason) && !this._manageContract.data.closed_at) {
      await this._utilsService.showSWALError({ text: "INSERT_CLOSED_AT_RESIGNATION" });
      return false;
    }

    let data: any = {
      closed_reason: this._manageContract.data.closed_reason,
      closed_at: this._manageContract.data.closed_at,
    };

    const userMinioDir: string = `users/${this.currentUser.hash}/`;
    if (this.fileResignation && data.closed_at) {
      const fileExt: string = this.fileResignation.split(";base64,")[0].split("/")[1];
      await this._utilsService
        .upload_media("documents", `${userMinioDir}${this.typeResignation === "resignation" ? "dimissioni" : "lettera-licenziamento"}/file.${fileExt}`, this.fileResignation)
        .then((response: any) => {
          data.resignation_url = response.url;
        })
        .catch(() => this._utilsService.showSWALError({ text: "ERROR_UPLOAD_FILE" }));
    }

    this._utilsService.showLoading();
    return this._userService
      .updateEmployeeResignation(this.currentUser.hash, data)
      .then(async () => {
        this._utilsService.hideLoading();
        await this._utilsService.showSWALSuccess({ text: "SUCCESS_UPDATE_EMPLOYEE_RESIGNATION" });
      })
      .catch(async (err: any) => {
        console.error(err);
        this._utilsService.hideLoading();
        await this._utilsService.showSWALError({ text: "ERROR_UPDATE_EMPLOYEE_RESIGNATION" });
      });
  }

  handlerChangeFileInput(event: any) {
    this.fileNameResignation = event.target.files[0].name;
    this._utilsService.convertFileToBase64(event, (e: any) => {
      this.fileResignation = e.target.result;
    });
  }

  // --- FINE FUNZIONI PER DIMISSIONI

  async updateContract() {
    if (!this.contract_is_changed) {
      await this._utilsService.showSWALError({ text: "NO_CONTRACT_CHANGES" });
      return false;
    }

    if (this._manageContract.typeIsIndeterminate) {
      if (!this._manageContract.data.contract || !this._manageContract.data.level || !this._manageContract.data.start_date || !this._manageContract.data.program || !this._manageContract.data.salary_yearly_gross) {
        await this._utilsService.showSWALError({ text: "CONTRACT_NOT_COMPLETE" });
        return false;
      }
    } else if (this._manageContract.typeIsStage) {
      if (!this._manageContract.data.contract || !this._manageContract.data.start_date || !this._manageContract.data.program || !this._manageContract.data.net_monthly_12 || !this._manageContract.data.end_date) {
        await this._utilsService.showSWALError({ text: "CONTRACT_NOT_COMPLETE" });
        return false;
      }
    } else {
      //Nel caso di apprendistato o determinato
      if (!this._manageContract.data.contract) {
        await this._utilsService.showSWALError({ text: "CONTRACT_NOT_COMPLETE_MISSING_CONTRACT" });
        return false;
      }
      if (!this._manageContract.data.level) {
        await this._utilsService.showSWALError({ text: "CONTRACT_NOT_COMPLETE_MISSING_LEVEL" });
        return false;
      }
      if (!this._manageContract.data.start_date) {
        await this._utilsService.showSWALError({ text: "CONTRACT_NOT_COMPLETE_MISSING_START_DATE" });
        return false;
      }
      if (!this._manageContract.data.program) {
        await this._utilsService.showSWALError({ text: "CONTRACT_NOT_COMPLETE_MISSING_PROGRAM" });
        return false;
      }
      if (!this._manageContract.data.net_monthly_12) {
        await this._utilsService.showSWALError({ text: "CONTRACT_NOT_COMPLETE_MISSING_NET_MONTHLY_12" });
        return false;
      }
      if (!this._manageContract.data.end_date) {
        await this._utilsService.showSWALError({ text: "CONTRACT_NOT_COMPLETE_MISSING_END_DATE" });
        return false;
      }
    }

    if (!this.valid_since) {
      await this._utilsService.showSWALError({ text: "PLEASE_SELECT_VALID_SINCE_DATE" });
      return false;
    }

    this._utilsService.showLoading();

    const data: any = {
      record_type: "revisione",
      ...this._manageContract.data,
      valid_since: this.valid_since,
    };

    return this._userService
      .updateEmployeeContract(this.currentUser.hash, data)
      .then(async () => {
        this.currentUser = await this._userService.get(this.currentUser.hash);
        this._utilsService.hideLoading();
        this.insert_valid_since = false;
        this.contract_is_changed = false;
        this.valid_since = null;
        await this._utilsService.showSWALSuccess({ text: "SUCCESS_UPDATE_EMPLOYEE_CONTRACT" });
      })
      .catch(async (err: any) => {
        this._utilsService.hideLoading();
        let text: string = "ERROR_UPDATE_EMPLOYEE_CONTRACT";
        if (err === "Cannot edit closed contract") {
          text = "ERROR_UPDATE_EMPLOYEE_CONTRACT_CONTRACT_CLOSED";
        }
        await this._utilsService.showSWALError({ text });
      });
  }

  async revokeResignation() {
    this._utilsService.showLoading();
    const hash = this.currentUser.hash;
    return this._userService
      .revokeResignation(hash)
      .then(() => {
        this.is_resigned = false;
        this.currentUser.contract.closed_at = null;
        this.currentUser.contract.resignation_url = null;
        this._utilsService.hideLoading();
        this._utilsService.showSWALSuccess({ text: "EMPLOYEE_RESIGNATION_REVOKED_SUCCESSFULLY" });
      })
      .catch(() => {
        this._utilsService.hideLoading();
        this._utilsService.showSWALSuccess({ text: "EMPLOYEE_RESIGNATION_REVOKED_ERROR" });
      });
  }

  ngOnDestroy() {
    this._manageContract.resetData();
  }

  transformTicketValue(target: any) {
    let { value }: any = target;
    if (String(value).length < 1) {
      value = "0,00";
    } else {
      if (value.split(",").length > 2) {
        value = value.split(",");
        const decimals: string = value.pop();
        value = value.join(".");
        value += "," + decimals;
      } else if (!value.includes(",")) {
        value += ",00";
      } else {
        value = value.replace(",", ".");
      }
    }

    target.value = value;
    this._manageContract.updateData();
    this.contract_is_changed = true;
  }

  async deleteAttachments(document) {
    if (!this._authenticationService.hasCapability("delete_employee_attachments")) {
      await this.router.navigateByUrl("/dashboard/main");
      return false;
    }
    let deleteText: string = await this._utilsService.translate("ALERT.CONFIRM_DELETE_TEXT");
    deleteText += await this._utilsService.translate("ALERT.CONFIRM_DELETE_THIS_OBJECT");
    deleteText += document.file_name;
    await this._utilsService
      .showSWALDeleteConfirmation({ text: deleteText })
      .then(async (result) => {
        if (result.value) {
          await this._userService.deleteEmployeeAttachments(document.id_attachment, this.currentUser.hash);
          await this._utilsService.showPopupItemDeleted().then(async () => {
            this.currentUser.contract.contract_attachments = this.currentUser.contract.contract_attachments.filter((attachments) => attachments.id_attachment !== document.id_attachment);
          });
        } else if (result.isDismissed) {
          await this._utilsService.showSWALError({
            title: "ABORTED_TITLE",
            text: "ABORTED_TEXT",
          });
        }
      })
      .catch(() => {
        this._utilsService.showSWALError({ text: "ERROR_DOCUMENT_REMOVE" });
      });
  }
}
